import React from 'react';
import PropTypes from 'prop-types';
import { Map } from 'immutable';

import { ButtonWithIcon } from '@els/els-react--button';
import GroupOfMoreCheckbox from './GroupOfMoreCheckbox';
import GroupOfMoreCheckRadio from './GroupOfMoreCheckRadio';
import GroupOfMoreInput from './GroupOfMoreInput';

import './GroupOfMore.scss';

const mapComponents = {
  checkbox: GroupOfMoreCheckbox,
  check_radio: GroupOfMoreCheckRadio,
  input: GroupOfMoreInput,
};

export default function GroupOfMore(props) {
  const { group, groupId, showMore, toggleMore } = props;
  const optionsIds = group.get('optionsIds');
  const options = group.get('options');

  return (
    <section className="group-of-more">
      {!showMore &&
        optionsIds.map((id) => {
          const option = options.get(id);
          const type = option.get('type');
          const Component = mapComponents[type];

          if (!Component) {
            Logger.error(`Unknown option's type for GroupOfMore component :${option.toJS()}`);
            return null;
          }

          return <Component key={id} {...props} groupId={groupId} optionId={id} option={option} />;
        })}
      <ButtonWithIcon
        type="link"
        sprite={showMore ? 'Plus' : 'Minus'}
        linkIconSize="xs"
        onClick={toggleMore}
        role="button"
        className={`group-of-more__toggle-button e2e-${showMore ? 'more-options' : 'fewer-options'}`}>
        {showMore ? 'More Options' : 'Fewer Options'}
      </ButtonWithIcon>
    </section>
  );
}

GroupOfMore.propTypes = {
  group: PropTypes.instanceOf(Map).isRequired,
  groupId: PropTypes.string.isRequired,
  showMore: PropTypes.bool.isRequired,
  toggleMore: PropTypes.func.isRequired,
};
